import { render, staticRenderFns } from "./OnboardingLessonLeaveDialog.vue?vue&type=template&id=0d4acb44&"
import script from "./OnboardingLessonLeaveDialog.vue?vue&type=script&lang=ts&"
export * from "./OnboardingLessonLeaveDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports